import {
  AnalyticsCollector,
  AnalyticsProvider,
} from "@lazarentertainment/analytics-collector"
import globalLogger from "@lazarentertainment/js-logger"
import { ConfigProvider } from "client/components/configuration/ConfigContext"
import { FillViewportView } from "client/components/layout/FillViewportView"
import { AnimationProvider } from "client/packages/animations/AnimationContext"
import { AppProps } from "next/app"
import getConfig from "next/config"
import Head from "next/head"
import Script from "next/script"
import { IntlProvider } from "react-intl"
import { ErrorBoundary } from "shared/components/ErrorBoundary"
import ErrorMessage from "shared/components/ErrorMessage"
import { baseTheme, dynamicTheme } from "shared/styles/baseTheme"
import { ThemeProvider } from "styled-components"

import "shared/styles/fonts.css"
import "src/client/designSystem/index.css"

export default function App({ Component, pageProps }: AppProps) {
  const { publicRuntimeConfig } = getConfig()
  globalLogger.logLevel = publicRuntimeConfig.app.logLevel

  const analytics = new AnalyticsCollector(publicRuntimeConfig.analytics)

  const accentColor = pageProps.params?.accentColor

  return (
    <>
      <Head>
        <title>Stage TEN Interactive Player</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <meta charSet="utf-8" />
        <Script
          async
          src="https://cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js?features=Intl"
        />
      </Head>
      <ConfigProvider config={publicRuntimeConfig}>
        <IntlProvider locale="en" defaultLocale="en" messages={{}}>
          <AnalyticsProvider client={analytics}>
            <AnimationProvider>
              {/* Nested ThemeProviders let us dynamically change theme colors */}
              <ThemeProvider theme={dynamicTheme(accentColor)}>
                <ThemeProvider theme={baseTheme}>
                  <ErrorBoundary
                    fallback={
                      <FillViewportView>
                        <ErrorMessage />
                      </FillViewportView>
                    }
                  >
                    <Component {...pageProps} />
                  </ErrorBoundary>
                </ThemeProvider>
              </ThemeProvider>
            </AnimationProvider>
          </AnalyticsProvider>
        </IntlProvider>
      </ConfigProvider>
    </>
  )
}
